import React from 'react';

import {IFieldMeta, EFieldType} from 'entities/metadata';
import {IDashboardEntry} from 'modules/data/data-types';
import {BarStatistics} from 'pages/meta-widget-page/statistics-widgets/bar-statistics';
import {CircleStatistics} from 'pages/meta-widget-page/statistics-widgets/circle-statistics';
import {HalfCircleStatistics} from 'pages/meta-widget-page/statistics-widgets/half-circle-statistics';
import {ProgressListStatistics} from 'pages/meta-widget-page/statistics-widgets/progress-list-statistics';

export const dashboardTypeResolver = (meta: IFieldMeta, entries: IDashboardEntry) => {
    switch (meta.type) {
    case EFieldType.BAR_STATISTICS:
        return (
            <BarStatistics
                title={meta.title}
                entries={entries}
                label={meta.label}
            />
        );
    case EFieldType.CIRCLE_STATISTICS:
        return (
            <CircleStatistics
                title={meta.title || ''}
                entries={entries}
            />
        );
    case EFieldType.HALF_CIRCLE_STATISTICS:
        return (
            <HalfCircleStatistics
                title={meta.title}
                entries={entries}
            />
        );
    case EFieldType.PROGRESS_LIST_STATISTICS:
        return (
            <ProgressListStatistics
                title={meta.title}
                entries={entries}
            />
        );
    case EFieldType.PROGRESS_LIST_STATISTICS_SECONDARY:
        return (
            <ProgressListStatistics
                title={meta.title}
                entries={entries}
                settings={{barColor: '#6BAAFF'}}

            />
        );
    default:
        return <></>;
    }
};
